module.exports = __webpack_public_path__ + "static/img/loading.d1fba74.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/loading.gif
// module id = /2aI
// module chunks = 1